import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';import nutritionInformationEnumerators from 'src/modules/nutritionInformation/nutritionInformationEnumerators';

export default [
  {
    name: 'name',
    label: i18n('entities.nutritionInformation.fields.name'),
    schema: schemas.string(
      i18n('entities.nutritionInformation.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'servingsNumber',
    label: i18n('entities.nutritionInformation.fields.servingsNumber'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.servingsNumber'),
      {},
    ),
  },
  {
    name: 'labelFormat',
    label: i18n('entities.nutritionInformation.fields.labelFormat'),
    schema: schemas.enumerator(
      i18n('entities.nutritionInformation.fields.labelFormat'),
      {
        "options": nutritionInformationEnumerators.labelFormat
      },
    ),
  },
  {
    name: 'servingQuantityUnit',
    label: i18n('entities.nutritionInformation.fields.servingQuantityUnit'),
    schema: schemas.string(
      i18n('entities.nutritionInformation.fields.servingQuantityUnit'),
      {},
    ),
  },
  {
    name: 'servingSizeWeight',
    label: i18n('entities.nutritionInformation.fields.servingSizeWeight'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.servingSizeWeight'),
      {},
    ),
  },
  {
    name: 'servingSizeUnit',
    label: i18n('entities.nutritionInformation.fields.servingSizeUnit'),
    schema: schemas.enumerator(
      i18n('entities.nutritionInformation.fields.servingSizeUnit'),
      {
        "options": nutritionInformationEnumerators.servingSizeUnit
      },
    ),
  },
  {
    name: 'calories',
    label: i18n('entities.nutritionInformation.fields.calories'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.calories'),
      {},
    ),
  },
  {
    name: 'totalFat',
    label: i18n('entities.nutritionInformation.fields.totalFat'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.totalFat'),
      {},
    ),
  },
  {
    name: 'saturatedFat',
    label: i18n('entities.nutritionInformation.fields.saturatedFat'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.saturatedFat'),
      {},
    ),
  },
  {
    name: 'transFat',
    label: i18n('entities.nutritionInformation.fields.transFat'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.transFat'),
      {},
    ),
  },
  {
    name: 'polyunsaturatedFat',
    label: i18n('entities.nutritionInformation.fields.polyunsaturatedFat'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.polyunsaturatedFat'),
      {},
    ),
  },
  {
    name: 'monounsaturatedFat',
    label: i18n('entities.nutritionInformation.fields.monounsaturatedFat'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.monounsaturatedFat'),
      {},
    ),
  },
  {
    name: 'cholesterol',
    label: i18n('entities.nutritionInformation.fields.cholesterol'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.cholesterol'),
      {},
    ),
  },
  {
    name: 'salt',
    label: i18n('entities.nutritionInformation.fields.salt'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.salt'),
      {},
    ),
  },
  {
    name: 'totalCarbohydrates',
    label: i18n('entities.nutritionInformation.fields.totalCarbohydrates'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.totalCarbohydrates'),
      {},
    ),
  },
  {
    name: 'dietaryFiber',
    label: i18n('entities.nutritionInformation.fields.dietaryFiber'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.dietaryFiber'),
      {},
    ),
  },
  {
    name: 'sugars',
    label: i18n('entities.nutritionInformation.fields.sugars'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.sugars'),
      {},
    ),
  },
  {
    name: 'addedSugars',
    label: i18n('entities.nutritionInformation.fields.addedSugars'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.addedSugars'),
      {},
    ),
  },
  {
    name: 'sugarAlcohol',
    label: i18n('entities.nutritionInformation.fields.sugarAlcohol'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.sugarAlcohol'),
      {},
    ),
  },
  {
    name: 'protein',
    label: i18n('entities.nutritionInformation.fields.protein'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.protein'),
      {},
    ),
  },
  {
    name: 'energy',
    label: i18n('entities.nutritionInformation.fields.energy'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.energy'),
      {},
    ),
  },
  {
    name: 'vitaminDataFormat',
    label: i18n('entities.nutritionInformation.fields.vitaminDataFormat'),
    schema: schemas.enumerator(
      i18n('entities.nutritionInformation.fields.vitaminDataFormat'),
      {
        "options": nutritionInformationEnumerators.vitaminDataFormat
      },
    ),
  },
  {
    name: 'calcium',
    label: i18n('entities.nutritionInformation.fields.calcium'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.calcium'),
      {},
    ),
  },
  {
    name: 'iron',
    label: i18n('entities.nutritionInformation.fields.iron'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.iron'),
      {},
    ),
  },
  {
    name: 'vitaminD',
    label: i18n('entities.nutritionInformation.fields.vitaminD'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.vitaminD'),
      {},
    ),
  },
  {
    name: 'potassium',
    label: i18n('entities.nutritionInformation.fields.potassium'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.potassium'),
      {},
    ),
  },
  {
    name: 'vitaminA',
    label: i18n('entities.nutritionInformation.fields.vitaminA'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.vitaminA'),
      {},
    ),
  },
  {
    name: 'vitaminC',
    label: i18n('entities.nutritionInformation.fields.vitaminC'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.vitaminC'),
      {},
    ),
  },
  {
    name: 'vitaminE',
    label: i18n('entities.nutritionInformation.fields.vitaminE'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.vitaminE'),
      {},
    ),
  },
  {
    name: 'vitaminK',
    label: i18n('entities.nutritionInformation.fields.vitaminK'),
    schema: schemas.integer(
      i18n('entities.nutritionInformation.fields.vitaminK'),
      {},
    ),
  },
];